/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetCommentsQueryResponse, FilesControllerGetCommentsPathParams, FilesControllerGetCommentsQueryParams } from "../../models/filesController/FilesControllerGetComments";

function getFilesControllerGetCommentsUrl(id: FilesControllerGetCommentsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/comments` as const }  
  return res
}

/**
 * @description Returns Liveblocks comments for the file, split into free-standing (page-anchored) and review (question-anchored) groups. Resolved threads are excluded. Pass checklistAppId to scope review comments to a single application.
 * @summary Get file comments for export
 * {@link /api/v1/files/:id/comments}
 */
export async function filesControllerGetComments(id: FilesControllerGetCommentsPathParams["id"], params?: FilesControllerGetCommentsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetCommentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFilesControllerGetCommentsUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}